"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var utils_1 = require("utils");
var useInitializedField_1 = require("./useInitializedField");
var INPUT_STYLE = "font-body border rounded p-2 flex flex-grow max-w-full focus:outline-none focus:border-actionable";
var getErrorStyles = function (error) {
    return error ? "border-error text-error" : "";
};
var getDisabledStyles = function (disabled) {
    return disabled ? "opacity-50 cursor-not-allowed" : "";
};
exports.Input = react_1.default.forwardRef(function (_a, forwardedRef) {
    var autoComplete = _a.autoComplete, name = _a.name, error = _a.error, _b = _a.type, type = _b === void 0 ? "text" : _b, disabled = _a.disabled, className = _a.className, placeholder = _a.placeholder, style = _a.style, min = _a.min, onBlur = _a.onBlur, onChange = _a.onChange, onFocus = _a.onFocus, onKeyUp = _a.onKeyUp, onKeyDown = _a.onKeyDown, value = _a.value, initiallyFocused = _a.initiallyFocused;
    var inputRef = (0, useInitializedField_1.useInitializedField)(forwardedRef, { initiallyFocused: initiallyFocused });
    var controlledValues = value ? { value: value } : {};
    return ((0, jsx_runtime_1.jsx)("input", __assign({ name: name, ref: inputRef, className: (0, utils_1.concatStyles)([
            INPUT_STYLE,
            getErrorStyles(error),
            getDisabledStyles(disabled),
            className,
        ]), type: type, min: min, disabled: disabled, placeholder: placeholder, style: style, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onKeyUp: onKeyUp, onKeyDown: onKeyDown, autoComplete: autoComplete ? "on" : "off" }, controlledValues), void 0));
});
exports.Input.displayName = "Form.Input";
